import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { canAccess } from "@/components/AdminTabs";
import ForcePasswordChange from "@/components/ForcePasswordChange";
import { ShieldAlert } from "lucide-react";

const NoAccess = () => (
  <div className="container-x py-20 flex flex-col items-center text-center" data-testid="admin-no-access">
    <ShieldAlert className="w-10 h-10 text-[#CC5A3A] mb-4" />
    <h1 className="font-heading text-2xl text-[#1E3F33] mb-2">No access to this section</h1>
    <p className="text-[#5C6B64] max-w-md">Your admin account doesn't have permission to view this area. Ask the main admin if you need access.</p>
  </div>
);

export default function ProtectedRoute({ children, role, feature, superOnly }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return <div className="container-x py-20 text-[#5C6B64]" data-testid="auth-loading">Loading…</div>;
  }
  // Keep the deep link (e.g. a lead notification) so login returns the user there.
  if (user === false) return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  if (user.role === "admin" && user.must_change_password) return <ForcePasswordChange />;
  if (superOnly && !user.is_super_admin) return <NoAccess />;
  if (feature && !canAccess(user, feature)) return <NoAccess />;
  return children;
}
